define.alias("shared/components/shared/schedule-navbar", "settings/components/shared/schedule-navbar");